"use strict";

module.exports = {
    "footer": {
        "about": "Hakkımızda",
        "about-url": "//company.yandex.com.tr/",
        "advert": "Reklamlar hakkında",
        "advert-url": "//advertising.yandex.ru/kupislova.xml?advertising",
        "apps": "Mobil uygulamalar",
        "apps-url": "//mobile.yandex.com.tr",
        "stat": "İstatistikler",
        "termsofuse": "Arama lisansı",
        "termsofuse-url": "//legal.yandex.com.tr/termsofuse/"
    }
};